import { Center ,Text,Box} from "@chakra-ui/react"


const Footer=()=>{
    return(
    <>
    <Box w='100%' bgColor='#000' h='40px'>
        <Center>
            <Text color={'#DC143C'}>
            Created By Avnish |  2024 All rights reserved.
            </Text>
        </Center>
    </Box>
    </>)
}
export default Footer